<template>
    <el-card shadow="never">
      <template #header>
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/workOrder' }">工单列表</el-breadcrumb-item>
            <el-breadcrumb-item>编辑工单</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <div style="width:80%">
        <el-form :model="form" label-width="180px">
          <el-form-item label="服务商">
            <el-select filterable v-model="form.supplierid" placeholder="请选择合适的服务商" size="large">
              <el-option
                v-for="item in baseData.supplierList"
                :key="item.id"
                :label="item.company"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="工单编号">
            {{ form.sn }}
          </el-form-item>
          <el-form-item label="商品信息">
            <el-table :data="form.goods" border style="width: 100%">
              <el-table-column prop="catagory_name" label="分类" width="120" />
              <el-table-column prop="goods_name" label="名称"/>
              <el-table-column prop="proId" label="商品ID" />
              <el-table-column prop="number" label="数量" width="80"/>
              <el-table-column prop="addTime" label="时间" width="170"/>
            </el-table>
          </el-form-item>
          <el-form-item label="上门时间">
            {{ form.appointmentDate }} {{ form.appointmentTime }}
          </el-form-item>
          <el-form-item v-if="form.finalAppointmentTime" label="最终确认上门时间">
            {{ form.finalAppointmentDate }} {{ form.finalAppointmentTime }}
          </el-form-item>
          <el-form-item label="联系人">
            <el-input v-model="form.name" maxlength="150" show-word-limit/>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="form.mobile" maxlength="20" show-word-limit/>
          </el-form-item>
          <el-form-item label="地址">
            <el-cascader v-model="form.areas" filterable :options="baseData.citydata" :props="props" @change="changeAreas"/>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="form.address" maxlength="250" show-word-limit/>
          </el-form-item>
          <el-form-item v-if="form.status == 8" label="拒单原因">
            {{ form.refuseReason }}
          </el-form-item>
          <el-form-item v-if="form.status == 8" label="拒单时间">
            {{ form.refuseTime }}
          </el-form-item>
          <el-form-item v-if="form.status == 2 || form.status == 3 || form.status == 4" label="接单时间">
            {{ form.receiveTime }}
          </el-form-item>
          <el-form-item v-if="form.status == 4" label="完成时间">
            {{ form.finishTime }}
          </el-form-item>
          <el-form-item label="核销备注" v-if="form.status == 5||form.status == 6">
            {{ form.dremark }}
          </el-form-item>
          <el-form-item label="核销附件" v-if="form.status == 5||form.status == 6">
            <el-image
              v-for="(item,index) in form.dimgs"
              :key=index
              style="width: 100px; height: 100px"
              :src="item" 
              :preview-src-list="form.dimgs">
            </el-image>
          </el-form-item>
          <el-form-item label="核销时间" v-if="form.status == 5||form.status == 6">
            {{ form.daddTime }}
          </el-form-item>
          <el-form-item label="评价" v-if="form.status == 5">
            <el-rate v-model="form.star" />
          </el-form-item>
          <el-form-item label="评价" v-if="form.status == 5">
            {{ form.evaluate }}
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="form.status">
              <el-radio :label="1" disabled="form.status >3">待接单</el-radio>
              <el-radio :label="2" disabled>已接单</el-radio>
              <el-radio :label="3" disabled>安装中</el-radio>
              <el-radio :label="4" disabled>待核销</el-radio>
              <el-radio :label="6" disabled>待评价</el-radio>
              <el-radio :label="5" disabled>已完成</el-radio>
              <el-radio :label="8" disabled>已拒单</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button @click="goBack">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import api from '@/api/index'
  import citydata from '@/assets/js/citydata'
  import { ElMessage, ElLoading } from 'element-plus'
  import {useRouter, useRoute} from 'vue-router'

  const router = useRouter()
  const route = useRoute()
  const baseData:any = reactive({
    citydata : [],
    supplierList : [],
  })
  const props = {
    expandTrigger: 'hover',
    children: 'cityArr',
    label: 'Name',
    value: 'Code',
  }
  const form:any = reactive({
    id: '',
    supplierid:'',
    secSupplierid:'',
    sn: '',
    goods_name: '',
    goods_id: '',
    number: '',
    appointmentDate: '',
    appointmentTime: '',
    goods:[],
    finalAppointmentDate: '',
    finalAppointmentTime: '',
    name: '',
    mobile: '',
    address: '',
    areas: [],
    province: '',
    city: '',
    area: '',
    star:0,
    evaluate:'',
    dremark:'',
    dimgs:'',
    daddTime:'',
    refuseReason: '',
    receiveTime: '',
    refuseTime: '',
    finishTime: '',
    status: 0,
  })
  const changeAreas = () => {
    form.province = form.areas[0]
    form.city = form.areas[1]
    form.area = form.areas[2]
  }
  const get = () => {
    const loading = ElLoading.service({lock: true})
    api.orderApi.get({id:route.params.id}).then((res:any)=>{
      if(res.code==200){
        form.supplierid = res.data.supplierid ? res.data.supplierid : ''
        form.secSupplierid = res.data.secSupplierid
        form.sn = res.data.sn
        form.goods_name = res.data.goods_name
        form.goods_id = res.data.goods_id
        form.number = res.data.number
        form.appointmentTime = res.data.appointmentTime
        form.goods = res.data.goods
        form.appointmentDate = res.data.appointmentDate
        form.finalAppointmentTime = res.data.finalAppointmentTime
        form.finalAppointmentDate = res.data.finalAppointmentDate
        form.name = res.data.name
        form.mobile = res.data.mobile
        form.address = res.data.address
        form.areas = res.data.areas
        form.province = res.data.province
        form.city = res.data.city
        form.area = res.data.area
        form.refuseReason = res.data.refuseReason
        form.dremark = res.data.dremark
        form.dimgs = res.data.dimgs
        form.daddTime = res.data.daddTime
        form.star = res.data.star
        form.evaluate = res.data.evaluate
        form.receiveTime = res.data.receiveTime
        form.refuseTime = res.data.refuseTime
        form.finishTime = res.data.finishTime
        form.status = res.data.status
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const onSubmit = () => {
    const loading = ElLoading.service({lock: true})
    if(!form.supplierid){
      ElMessage.error('请选择合适的服务商')
      loading.close()
      return false
    }
    api.orderApi.save(form).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        router.push("/workOrder");
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const getSupplierList = () => {
    api.supplierApi.alllist({}).then((res:any)=>{
      if(res.code==200){
        baseData.supplierList = res.data
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const goBack = () => {
    router.go(-1);
  }
  onMounted(() => {
    baseData.citydata = citydata.provinceArr
    form.id = route.params.id
    get()
    getSupplierList()
  })
  </script>